import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=343f6e34&scoped=true&"
import script from "./Step6.vue?vue&type=script&lang=ts&"
export * from "./Step6.vue?vue&type=script&lang=ts&"
import style0 from "./Step6.vue?vue&type=style&index=0&id=343f6e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343f6e34",
  null
  
)

export default component.exports